import { useContext } from 'react';
import {
  AuthenticationContext,
  AuthenticationContextValue
} from '../context/AuthenticationContext';

export function useAuth(): AuthenticationContextValue {
  return useContext(AuthenticationContext);
}
